module.exports = __webpack_public_path__ + "static/media/arrow-light.812c7eb3.svg";